import { render, staticRenderFns } from "./CaseImg.vue?vue&type=template&id=504043e8&scoped=true&"
import script from "./CaseImg.vue?vue&type=script&lang=js&"
export * from "./CaseImg.vue?vue&type=script&lang=js&"
import style0 from "./CaseImg.vue?vue&type=style&index=0&id=504043e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504043e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504043e8')) {
      api.createRecord('504043e8', component.options)
    } else {
      api.reload('504043e8', component.options)
    }
    module.hot.accept("./CaseImg.vue?vue&type=template&id=504043e8&scoped=true&", function () {
      api.rerender('504043e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/CaseImg.vue"
export default component.exports